import $ from "jquery";

const ACTIVE_CLASS = "show";
const PREVENT_SCROLL_CLASS = "prevent-scroll";
const MARKET_BLOCK_SELECTOR = ".market-block";
const MARKET_SELECTOR = ".market-block__overlay";
const OPEN_COUNTRY_TRIGGER_SELECTOR = "[data-country-select-trigger]";
const CLOSE_COUNTRY_TRIGGER_SELECTOR = "[data-country-close-trigger]";

export class CountryInfoModule {
    constructor() {
        this.scrollPos = 0;
        this.setupEvents();
    }

    setupEvents() {
        $("body").on("click", OPEN_COUNTRY_TRIGGER_SELECTOR, ev => {
            const $target = $(ev.currentTarget);
            const $parent = $target.closest(MARKET_BLOCK_SELECTOR);
            const $marketOverlay = $parent.find(MARKET_SELECTOR);
            this.showMarket($marketOverlay);
        });

        $("body").on("click", CLOSE_COUNTRY_TRIGGER_SELECTOR, ev => {
            const $target = $(ev.currentTarget);
            const $parent = $target.closest(MARKET_BLOCK_SELECTOR);
            const $marketOverlay = $parent.find(MARKET_SELECTOR);

            this.closeMarket($marketOverlay);
        });
    }

    showMarket($market) {
        this.scrollPos = $(document).scrollTop();

        $market.addClass(ACTIVE_CLASS);
        $("body").addClass(PREVENT_SCROLL_CLASS);
    }

    closeMarket($market) {
        $market.removeClass(ACTIVE_CLASS);
        $market.replaceWith($market.prop("outerHTML"));

        $("body").removeClass(PREVENT_SCROLL_CLASS);

        if (this.scrollPos) {
            $(document).scrollTop(this.scrollPos);
        }
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/front/App/CountryInfoModule.js